import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        h5LoginData:null,
        loginData: null,
        accountData: null,
        userData: null,
        screen: null,
        userName: null,
        pid:null,
        nav:null,
        code:null
    },
    mutations: {
        setLoginData (state, msg) {
            state.loginData = msg
        },
        setH5LoginData (state, msg) {
            state.h5LoginData = msg
        },
        setNav(state, msg) {
            state.nav = msg
        },
        setCode(state, msg) {
            state.code = msg
        },
        setPid (state, msg) {
            state.pid = msg
        },
        setAccountData (state, msg) {
            state.accountData = msg
        },
        setUserData (state, msg) {
            state.userData = msg
        },
        setScreen (state, msg) {
            state.screen = msg
        },
        setUserName (state, msg) {
            state.userName = msg
        }
    },
    actions: {
    },
    modules: {
    },
    getters:{

    }
})
